import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../shared/services/authentication/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const login = localStorage.getItem("isLoggedIn");
    if (login) {
      const isAuthenticated = JSON.parse(login);
      if (isAuthenticated) {
        return true;
      } else {
        return this.router.createUrlTree(["/login"]);
      }
    } else {
      return this.router.createUrlTree(["/login"]);
    }
  }
}
